import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ReportsAbstractService } from './reports-abstract.service';

@Injectable()
export class SingleStepReportService extends ReportsAbstractService {
  public reportRoute: string = 'single_step_report';

  constructor(protected http: HttpClient) {
    super(http);
    this.route = this.reportRoute;
  }
}
